module.exports = __webpack_public_path__ + "static/media/ns8.6e7ed499.svg";